"use client"

import { SquareDot } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareDotIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareDotIcon = component(Icon)({ as: SquareDot })
